import React from 'react';
import { Card, CardContent, CardHeader } from '@mui/material';
import { Title, useGetList } from 'react-admin';

const Dashboard = () => {
    const { total: usersTotal } = useGetList('users', { pagination: { page: 1, perPage: 1 } });
    const { total: salesRepsTotal } = useGetList('sales_reps', { pagination: { page: 1, perPage: 1 } });
    const { total: homesTotal } = useGetList('homes', { pagination: { page: 1, perPage: 1 } });
    const { total: servicesTotal } = useGetList('services', { pagination: { page: 1, perPage: 1 } });
    const { total: knocksTotal } = useGetList('knocks', { pagination: { page: 1, perPage: 1 } });

    return (
        <div style={{ padding: '20px' }}>
            <Title title="NeverKnock Admin Dashboard" />
            
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '20px', marginTop: '20px' }}>
                <Card>
                    <CardHeader title="Total Users" />
                    <CardContent>
                        <div style={{ fontSize: '2rem', fontWeight: 'bold', color: '#1976d2' }}>
                            {usersTotal || 0}
                        </div>
                    </CardContent>
                </Card>
                <Card>
                    <CardHeader title="Sales Representatives" />
                    <CardContent>
                        <div style={{ fontSize: '2rem', fontWeight: 'bold', color: '#2e7d32' }}>
                            {salesRepsTotal || 0}
                        </div>
                    </CardContent>
                </Card>
                <Card>
                    <CardHeader title="Registered Homes" />
                    <CardContent>
                        <div style={{ fontSize: '2rem', fontWeight: 'bold', color: '#ed6c02' }}>
                            {homesTotal || 0}
                        </div>
                    </CardContent>
                </Card>
                <Card>
                    <CardHeader title="Available Services" />
                    <CardContent>
                        <div style={{ fontSize: '2rem', fontWeight: 'bold', color: '#9c27b0' }}>
                            {servicesTotal || 0}
                        </div>
                    </CardContent>
                </Card>
                <Card>
                    <CardHeader title="Total Knocks" />
                    <CardContent>
                        <div style={{ fontSize: '2rem', fontWeight: 'bold', color: '#d32f2f' }}>
                            {knocksTotal || 0}
                        </div>
                    </CardContent>
                </Card>
            </div>
        </div>
    );
};

export default Dashboard; 